export * from './application';
export * from './entity';
export * from './infrastructure';

import { Stay22 } from "./application";

Stay22.initialize();
